import React, { useEffect } from 'react';
import { FunctionComponent, useState } from 'react';
import Form from 'react-bootstrap/Form';
import BaseButton from '@components/common/BaseButton';
import KlaviyoHelper, { KlaviyoUser } from '@helpers/KlaviyoHelper';
import config from '@config';

interface HomeNewsletterBoxProps
{

}

const HomeNewsletterBox: FunctionComponent<HomeNewsletterBoxProps> = (props) =>
{
    const [lastName, setLastName] = useState('');
    const [firstName, setFirstName] = useState('');
    const [email, setEmail] = useState('');
    const [isWorking, setIsWorking] = useState(false);
    const [successMessage, setSuccessMessage] = useState<string | undefined>(undefined);
    const [errorMessage, setErrorMessage] = useState<string | undefined>(undefined);

    useEffect(() =>
    {
        // Reset the error message when the email changes
        setErrorMessage(undefined);
    }, [email]);

    /**
     * Validate the email address
     */
    const validate = () =>
    {
        let re = /\S+@\S+\.\S+/;

        return re.test(email);
    }

    /**
     * Create a new profile in Klaviyo and subscribe it to the list
     */
    const subscribe = async () =>
    {
        if (email === '') return;
        if (!validate()) return;

        setIsWorking(true);

        // Create a new profile in Klaviyo
        let klaviyoUser: KlaviyoUser = {
            email: email,
        }
        let klaviyoUserId = await KlaviyoHelper.instance.createProfile(klaviyoUser);
        if (klaviyoUserId != null)
        {
            // Subscribe the profile to the list
            let success = await KlaviyoHelper.instance.subscribeKlaviyoProfileToList(undefined, config.klaviyoNewsLetterListId, email);
            if (success)
            {
                setSuccessMessage('Vă mulțumim pentru înscriere! Acum sunteți abonat la newsletter-ul BBMoto.');
                setLastName('');
                setFirstName('');
                setEmail('');
            }
            else
            {
                setErrorMessage('A apărut o eroare la înscrierea adresei de email pe lista de newsletter. Vă rugăm să încercați din nou.');
            }
        }
        else
        {
            setErrorMessage('A apărut o eroare la înscrierea adresei de email. Vă rugăm să încercați din nou.');
        }

        setIsWorking(false);
    }

    /** Render */
    return (
        <div
            className="home-newsletter h-100 d-lg-flex flex-column base-box"
            style={{ backgroundImage: 'url(' + config.defaultPublicDirBaseUrl + 'template/images/home-bg-1.webp)' }}
        >
            <div className="flex-grow-1 mb-4 mb-lg-3">
                <div className="home-newsletter-title">Newsletter BBMoto</div>
                <div className="home-newsletter-description">Nu ratați nicio noutate, promoție sau articol!</div>
            </div>

            <div className="home-newsletter-bottom">
                <div className="home-newsletter-bottom-alerts">
                    {successMessage && <div className="home-newsletter-bottom-alert bg-secondary">{successMessage}</div>}
                    {errorMessage && <div className="home-newsletter-bottom-alert bg-primary">{errorMessage}</div>}
                </div>
                <div className="mb-3 mb-lg-0">
                    <div className="row">
                        <div className="home-newsletter-bottom-input-wrapper col-lg-2">
                            <Form.Control
                                type="text"
                                placeholder="Numele dvs."
                                disabled={isWorking}
                                value={lastName}
                                onChange={(e) => setLastName(e.target.value)}
                                className="w-100"
                            />
                        </div>
                        <div className="home-newsletter-bottom-input-wrapper col-lg-2">
                            <Form.Control
                                type="text"
                                placeholder="Prenumele dvs."
                                disabled={isWorking}
                                value={firstName}
                                onChange={(e) => setFirstName(e.target.value)}
                                className="w-100"
                            />
                        </div>
                        <div className="home-newsletter-bottom-input-wrapper col-lg-4">
                            <Form.Control
                                type="email"
                                placeholder="Adresa dvs. de email"
                                disabled={isWorking}
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                className="w-100"
                            />
                        </div>
                        <div className="home-newsletter-bottom-button-wrapper col-lg-4">
                            <BaseButton
                                text={!isWorking ? 'Înscrieți-vă' : 'Vă rugăm așteptați...'}
                                variant="primary"
                                disabled={isWorking}
                                width={100}
                                onClick={() => subscribe()}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default HomeNewsletterBox;